import React from 'react';
import { Link } from 'react-router-dom';
export function PrivacySection() {
  return <div className="bg-white rounded-xl shadow-md p-6" data-id="element-31">
      <h2 className="text-2xl font-bold mb-4" data-id="element-32">Privacy and Data Protection</h2>
      <p className="text-gray-700 mb-6" data-id="element-33">
        We take data protection seriously and ensure that all participant data
        is handled with the utmost care and in compliance with GDPR regulations.
        For more information, please refer to our:
      </p>
      <div className="flex flex-col sm:flex-row gap-4" data-id="element-34">
        <Link to="/privacy" className="inline-block px-5 py-2.5 bg-purple-100 text-purple-700 rounded-lg font-medium hover:bg-purple-200 transition-colors" data-id="element-35">
          Privacy Policy
        </Link>
        <Link to="/terms" className="inline-block px-5 py-2.5 bg-blue-100 text-blue-700 rounded-lg font-medium hover:bg-blue-200 transition-colors" data-id="element-36">
          Terms of Service
        </Link>
        <Link to="/gdpr" className="inline-block px-5 py-2.5 bg-green-100 text-green-700 rounded-lg font-medium hover:bg-green-200 transition-colors" data-id="element-37">
          GDPR Compliance
        </Link>
      </div>
    </div>;
}